var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#02CB63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1118 17.975C22.0597 17.0083 20.4426 17.0083 19.3905 17.975C19.3474 18.0146 19.3014 18.0606 19.2417 18.1204L18.3442 19.0179C17.4411 19.921 17.062 21.2229 17.339 22.4697C18.911 29.5436 24.4355 35.0681 31.5094 36.6401C32.7562 36.9171 34.0581 36.538 34.9612 35.6349L35.8586 34.7375C35.9184 34.6777 35.9644 34.6317 36.004 34.5886C36.9708 33.5365 36.9708 31.9193 36.004 30.8673C35.9644 30.8241 35.9184 30.7781 35.8586 30.7184L34.3894 29.2491C33.3693 28.229 31.8287 27.9372 30.5063 28.5137C29.7492 28.8437 28.8672 28.6767 28.2832 28.0927L25.8864 25.6959C25.3024 25.1119 25.1354 24.2299 25.4654 23.4728C26.0418 22.1504 25.7501 20.6098 24.73 19.5897L23.2607 18.1204C23.2009 18.0607 23.1549 18.0146 23.1118 17.975ZM20.4054 19.0796C20.8836 18.6401 21.6187 18.6401 22.0969 19.0796C22.1134 19.0947 22.1351 19.1161 22.2111 19.1922L23.6693 20.6504C24.2533 21.2344 24.4204 22.1163 24.0903 22.8735C23.5139 24.1959 23.8056 25.7364 24.8257 26.7565L27.2225 29.1534C28.2426 30.1735 29.7832 30.4652 31.1056 29.8887C31.8627 29.5587 32.7447 29.7258 33.3287 30.3098L34.7869 31.768C34.8629 31.844 34.8843 31.8657 34.8995 31.8822C35.3389 32.3604 35.3389 33.0955 34.8995 33.5737C34.8843 33.5902 34.8629 33.6118 34.7869 33.6879L33.9005 34.5742C33.3601 35.1147 32.5809 35.3416 31.8348 35.1758C25.3295 33.7302 20.2489 28.6496 18.8033 22.1443C18.6375 21.3982 18.8644 20.619 19.4049 20.0785L20.2912 19.1922C20.3673 19.1161 20.3889 19.0947 20.4054 19.0796Z",
    fill: "#E2FFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8586859bce6625e89c354b1cfe59d38f.svg";
export { ForwardRef as ReactComponent };